import React, { useEffect, useState } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import ReactModal from "react-modal";
import { useNavigate } from "react-router-dom";
import { useForm, FormProvider, Controller  } from "react-hook-form";
import { toast } from "react-toastify";
import useAxios from "../../hooks/useAxios";
import axiosInstance from "../../apis/commonAPI";





const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "Pink",
    padding: "3em",
  },
};

const RegisterPopUp = ({ modalOpen, closeModal, phoneData, otpData, otpHandle  }) => {
  const navigate = useNavigate();
      const [forgotPasswordFormFlag, setForgotPasswordFormFlag] = useState(false);
      const [getNewOtpFlag, setGetNewOtpFlag] = useState(false);
      const [newOTP, setNewOTP] = useState(null);
      const [updatePasswordData, setUpdatePasswordData] = useState({});

       const [resOtpData, errorSubmitOtp, loadingSubmitOtp, axiosSubmitOtp] =
             useAxios();
       const [newPassData, errorNewPassword, loadingNewPassword, axiosSubmitNewPassword] =
             useAxios();
      
               const getNewOTP = (url) => {
                axiosSubmitOtp({
                             axiosInstance: axiosInstance,
                             url: url,
                             method: "GET",
                           });
                         };
  

 const form = useForm({
    defaultValues: {
      newOtpPassword: "",
    },
  });

  const {
    register,
    control,
    handleSubmit,
    formState,
    watch,
    setValue,
    getValues,
    resetField
  } = form;
  const { errors } = formState;
 
 

    useEffect(() => {
      if (otpData) {
        resetField("otpVerify");
        resetField("newOtpPassword");
      }
    }, [otpData]);

    function isSixDigitOTP(otp) {
      return /^\d{6}$/.test(otp);
    }

    const handleNewOtp = (getOtp) => {
      if(getOtp && isSixDigitOTP(getOtp)){
        setNewOTP(getOtp);
      }else{
        setNewOTP(null);
       
      }

    }
    const handleNewPassword = async (getPassword) => {
      if(getPassword && phoneData ){
        let passData = {
          password: getPassword,
          phone: `91${phoneData}`
        }
        setUpdatePasswordData(passData)
      }else{
        toast.success("Error!! Password could not be blank", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 500,
        })
      }

    }
const handleResendOtp = () => {
  setUpdatePasswordData({})
  
if(phoneData){
  getNewOTP(`users/forgot-password-otp/${phoneData}`)
  setGetNewOtpFlag(true);

}else{
  navigate("/forgot-password");
  setGetNewOtpFlag(false);
}
  

}

useEffect(() => {
  if(getNewOtpFlag && resOtpData?.[0]?.success){
    console.log("resOtpData?.[0]?.data",resOtpData?.[0]?.data)
    otpHandle(resOtpData?.[0]?.data);

    toast.success(resOtpData?.[0]?.message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 500,
    })

  }else if(getNewOtpFlag && !resOtpData?.[0]?.success){
    toast.error(resOtpData?.[0]?.message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 500,
    })

  }
  setGetNewOtpFlag(false);
},[resOtpData])
console.log("test phon",phoneData)
  console.log("test otpData",otpData)

  useEffect(() => {
    if(newPassData?.[0]?.success){
      toast.success(newPassData?.[0]?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 500,
      });
      navigate("/login?userRegister=passUpdated");
      
    }else if(!newPassData?.[0]?.success){
      toast.error(newPassData?.[0]?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 500,
      })

    }


  },[loadingNewPassword])
  return (
    <div >
      <ReactModal
        isOpen={modalOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Password Modal"
        ariaHideApp={false} ///  shows error if ariaHideApp is not define as false
      >
       
       
         {
          forgotPasswordFormFlag?<>
          {/* <FormProvider {...form}>
            <form onSubmit={handleSubmit(onFormSubmit)} noValidate> */}
            
              <div className="mt-10 btn-wrapper">
                <span>   <input
                  id="newOtppassword"
                  {...register("newOtpPassword", {
                    required: {
                      value:true,
                      message: "New Password Field is Required",
                    },
                    minLength: {
                      value: 4,
                      message: "Password must be at least 4 characters"
                    }
                  
                  })}
                  type="password"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter New Password"
                  onChange= {(e) => {handleNewPassword(e.target.value)}}
                />
               
                </span>
               
             <span>
             <button
                  type="button"
                  className="btn-sm btn-secondary rounded-10"
                 onClick =  {async () => {
                  resetField("newOtpPassword");
if(updatePasswordData?.password && updatePasswordData?.phone){
  await axiosSubmitNewPassword({
    axiosInstance: axiosInstance,
    url: `users/update-password`,
    method: "POST",
    requestConfig: {
      data: updatePasswordData,
    },
  });

}else{
  toast.error("Error!! Enter Password", {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 500,
  })
}
                 
                  
                   
                    
                  }}
                 
                >Submit</button>
             </span>
               
              </div>
              
              {/* </form>
              </FormProvider> */}
              <div className="mt-20  text-center">
          
         
          <button
           className="btn-sm  btn-red rounded-5"
           onClick={() => {setNewOTP(null);setForgotPasswordFormFlag(false);closeModal(false);setUpdatePasswordData({})}}
         >
           Cancel
         </button>
         </div>
          </>:<>
           <div className="mt-10 btn-wrapper">
                <span> <input
                      id="otpVerify"
                      {...register("otpVerify", {
                        required: {
                          value: true,
                          message: "OTP is Exactly 6 digits",
                        },
                        pattern: {
                          value: /^[0-9]/,
                          message: "Enter 6 Digits OTP",
                        },
                        minLength: { value: 6, message: "Enter 6 digits OTP" },
                        maxLength: { value: 6, message: "Enter 6 digits OTP" },
                      })}
                     
                      type="number"
                      className="form-control rounded-10 mb-15"
                      placeholder="Enter 6 digits OTP.."
                      onChange= {(e) => {handleNewOtp(e.target.value)}}
    
                                      />
                                                      </span>
               
             <span>
             <button
                  type="button"
                  className="btn-sm btn-secondary rounded-10"
                  onClick={() => {
                    resetField("newOtpPassword");
                  
                    if (newOTP == otpData) {
                      setForgotPasswordFormFlag(true);
                      toast.success("OTP Verified Successfully", {
                        position: toast.POSITION.TOP_RIGHT,
                      });
                    } else {
                      toast.error("Please Enter Valid OTP !!", {
                        position: toast.POSITION.TOP_RIGHT,
                      });
                    }
                  }}
                  
                >
                  Verify OTP
                  </button>
             </span>
               
              </div>

              <div className="mt-20  text-center">
          
          <button
           className="btn-sm  btn-green rounded-5 mr-5"
           onClick={handleResendOtp}

           
         >
           Resend OTP
         </button>
          <button
           className="btn-sm  btn-red rounded-5"
           onClick={() => {setNewOTP(null);setForgotPasswordFormFlag(false);closeModal(false);setUpdatePasswordData({})}}
         >
           Cancel
         </button>
         </div>
          </>
         }
        
  
        
        
      
       
      </ReactModal>
    </div>
  );
};

export default RegisterPopUp;
